export default {
    message: {
        currencySymbol: "$",
        currencyDesc: "USD",
        tiers: {
            t1: {
                label: "Workspace Standard",
                desc: "<p>Základní řešení Workspace, které nabízí inteligentní funkce pro moderní pracovníky používající aplikace SaaS, webové aplikace a služby pro sdílení souborů.</p><p>Zahrnuje jednotné přihlašování s podporou vícefaktorového ověření ve všech aplikacích, inteligentní pracovní prostor díky mikroaplikacím, přizpůsobená vlákna a virtuální asistenci a také službu Citrix Content Collaboration Standard s neomezeným úložištěm dat.</p>"
            },
            t2: {
                label: "Workspace Premium",
                desc: "<p>Úplné řešení pracovního prostoru pro pracovníky, kteří potřebují kompletní digitální pracovní prostor s podrobným zabezpečením, ale nevyžadují virtuální aplikace a desktopy.</p><p>Zahrnuje funkce řešení Workspace Standard a navíc pokročilé zabezpečení pro aplikace SaaS a web, jednotnou správu koncových bodů a službu Content Collaboration Premium.</p>"
            },
            t3: {
                label: "Workspace Premium Plus",
                desc: "<p>Ucelené řešení pracovního prostoru včetně možností hybridního nasazení pro řešení Citrix Virtual Apps and Desktops.</p><p>Zahrnuje funkce řešení Workspace Premium a navíc možnost správy cloudu pro řešení Citrix Virtual Apps and Desktops.</p>"
            },
            t4: {
                label: "Workspace Essentials",
                desc: "<p>Citrix Workspace Essentials helps small and medium businesses protect their data by simplifying and securing the login process to SaaS and web applications.</p><p>Includes single sign-on to SaaS and web applications with multi-factor authentication to further secure the login process, helping to reduce the odds of account compromise by 99.9% .</p>"
            },
            terms: "* Za uživatele a měsíc",
            btn1: "Zobrazit tabulku funkcí"
        },
        features: {
            disclaimer1: "* Měsíční průměrná maloobchodní cena doporučená výrobcem (MSRP) v USD za uživatele při 500 uživatelích s tříletým předplatným. Skutečná cena se může lišit.<br />Nabídka licencí na řešení Citrix Workspace začíná na 25 uživatelích.",
            disclaimer2: "** Služba Workspace Premium nezahrnuje řešení Workspace Analytics u místních nasazení řešení Citrix Virtual Apps and Desktops."
        },
        calculator: {
            edition: "Vyberte si verzi",
            title: "Vypočítejte si cenu",
            users: "Vyberte uživatele",
            estCost: "Vaše odhadované měsíční náklady",
            btn1: "Promluvit si s odborníkem",
            minUserMsg: "Nabídka licencí začíná na 25 uživatelích. Zkuste to znovu.",
            lowUserMsg: "Máte méně než 500 uživatelů? Pomůžeme vám vyhovět potřebám malých a středních podniků.",
            volumeDiscount: "Více než 2 500 uživatelů? Získejte množstevní slevy.",
            contract1: "Roční smlouva",
            contract3: "Tříletá smlouva",
            contract3savings: "Úspora 20 %",
            term: "Za uživatele a měsíc",
        },
        stats: {
            title: "Výhody pro vás",
            stat1: {
                title: "Lepší prostředí pro zaměstnance",
                desc: "<b>4 z 5</b> lídrů v oboru IT se domnívají, že je prostředí zaměstnanců zásadní pro digitální transformaci."
            },
            stat2: {
                title: "Dejte zaměstnancům možnost volby",
                desc: "<b>78 %</b> obchodních lídrů se shoduje, že pokud mají zaměstnanci možnost vybrat si aplikace a zařízení, které používají, zlepšuje se tím jejich pracovní prostředí."
            },
            stat3: {
                title: "Jednodušší přístup",
                desc: "<b>47 %</b> obchodních lídrů uvádí, že na angažovanosti zaměstnanců se nejvíce podílí snadný přístup k informacím potřebným k odvádění práce."
            },
            btn1: "Promluvit si s odborníkem",
            disclaimer: "Zdroj: <a href='https://theexperienceofwork.economist.com/Citrix_The_Experience_of_Work_BriefingPaper.pdf' target='_blank'>The Economist</a>"
        }
    }
}